import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkProvider } from '../../../providers/network/network';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ReportingP1Service } from '../../../providers/dactech-back/reporting-p1.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertesEmplacementDto } from '../../../../api/models/alertes-emplacement-dto';
import { SiteIntervenantDto } from '../../../../api/models/site-intervenant-dto';
import { SiteIntervenantService } from '../../../providers/dactech-back/site-intervenant.service';
import { UserService } from '../../../providers/auth/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'conduite-p1-widget',
  templateUrl: './conduite-p1-widget.component.html',
  styleUrl: './conduite-p1-widget.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, TranslateModule],
})
export class ConduiteP1WidgetComponent implements OnInit {
  @Input() resetSubject: Observable<boolean> = new Observable<boolean>();
  private destroyRef = inject(DestroyRef);

  readonly isOnline: WritableSignal<boolean> = signal<boolean>(false);
  readonly isLoading: WritableSignal<boolean> = signal<boolean>(false);
  readonly hasAlerteTemperatureError: WritableSignal<boolean> = signal<boolean>(false);

  readonly numberOfAlertsTemperature: WritableSignal<number> = signal<number>(0);
  readonly dkCodesSites = signal<string[]>([]);

  readonly showConduiteP1Widget = computed(() => {
    return this.dkCodesSites().length > 0;
  });
  readonly hasAlertTemperature = computed(() => {
    return this.numberOfAlertsTemperature() > 0;
  });

  constructor(
    private readonly networkProvider: NetworkProvider,
    private readonly reportingP1Service: ReportingP1Service,
    private readonly siteIntervenantService: SiteIntervenantService,
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  async ngOnInit() {
    this.networkProvider.networkStatusSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isOnline.set(this.networkProvider.isConnected());
    });
    await this.refresh();

    this.resetSubject.subscribe((response) => {
      if (response) {
        this.refresh();
      }
    });
  }

  async refresh() {
    this.isLoading.set(true);
    try {
      const currentUser = this.userService.getCurrentUser();
      const siteP1IntervenantDto: SiteIntervenantDto = await this.siteIntervenantService.getSiteP1Intervenant(
        currentUser.id
      );
      this.dkCodesSites.set(siteP1IntervenantDto.dk_codes_sites);
      const hasSitesP1: boolean = siteP1IntervenantDto.dk_codes_sites.length > 0;
      if (hasSitesP1) {
        const alertsP1Emp: AlertesEmplacementDto = await this.reportingP1Service.getAlertesTemperature(
          siteP1IntervenantDto.dk_codes_sites
        );
        this.numberOfAlertsTemperature.set(alertsP1Emp.nbr_alertes_temperature);
      }
      this.isLoading.set(false);
    } catch (error) {
      console.log('Error de cecuperation des alertes', error);
      this.isLoading.set(false);
      this.hasAlerteTemperatureError.set(true);
    }
  }

  async navigateToTdbMensuel() {
    await this.router.navigate(['mnt/reporting-p1/tdb-mensuel'], {
      state: {
        dkCodesSites: this.dkCodesSites(),
      },
    });
  }

  async goToAlertesTemperaturesPage() {
    await this.router.navigate(['mnt/reporting-p1/alertes-temperatures']);
  }
}
